export class CreateArchivoRequest {
  public descripcion: string|null=null;
  public content:string|null=null;
  public fechaAlta:Date = new Date ;
  public encriptado:boolean= false;
  public contentType: string|null=null;
  public nombre: string="";
}
